"use client";

import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthError, selectAuthStatus } from "store";
import { forgotPassword } from "store";
import Logo from "./logo";
import EveLogo from "icons/src/everest-logoblack.svg";
import { Button } from "ui/components/button";
import { Input } from "ui/components/input";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export function ForgotPassword() {
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const authStatus = useSelector(selectAuthStatus);
    const authError = useSelector(selectAuthError);

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(forgotPassword({ email })).then((result) => {
            if (result.type === 'auth/forgotPassword/fulfilled') {
                toast.success("Reset password link sent to your email");
                navigate("/login");
            }
        });
    };
    return (
        <div className="min-h-screen bg-background md:p-16 gap-x-6 flex justify-center items-center relative">
            {/* Content wrapper */}
            <div className="w-full flex items-top justify-center">
                {/* Sign-in form container */}
                <div className="max-w-sm px-6 py-16 md:p-0 w-full ">
                    {/* Logo and header section */}
                    <div className="space-y-6 mb-10 items-center flex flex-col">
                        <img src={EveLogo} alt="Logo" className="w-55" />
                    </div>
                    {/* Input fields section */}
                    <div className="space-y-4 mb-6">
                        <Input
                            id="email"
                            placeholder="example@gmail.com"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    {/* Sign-in button and sign-up link section */}
                    <div className="flex flex-col space-y-6">
                        {authError && (
                            <p className="text-red-500 text-sm text-center mb-4">
                                {authError}
                            </p>
                        )}
                        <Button
                            className="w-full"
                            onClick={handleSubmit}
                            disabled={authStatus === "loading"}
                        >
                            Send Link
                        </Button>
                    </div>
                    {/* Centered Powered by section */}
                    <div
                        className="w-full flex justify-center items-center gap-2 mt-8 opacity-80"
                    >
                        <span className="text-ms text-muted-foreground">Powered by</span>
                        <Logo width={80} height={25} />
                    </div>
                </div>
            </div>
        </div>
    );
}
